import {inject, injectable} from 'inversify';

import {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';
import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {FoodDiaryModel} from './FoodDiary.model';

@injectable()
export class FoodDiaryFactory
  implements BaseDomainFactory<FoodDiaryModel, FoodDiaryModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: FoodDiaryModel.Props): FoodDiaryModel {
    return this.modelsRegistry.put(new FoodDiaryModel(props));
  }
}
